// extracted by mini-css-extract-plugin
export default {"container":"Monitor_container__yFwIP","rows":"Monitor_rows__7U5vJ","boxes":"Monitor_boxes__ti4-X","attitude":"Monitor_attitude__kzV9S"};